import { createReducer, on } from '@ngrx/store';
import {
  deleteExposedApi,
  deleteExposedClient,
  deleteExposedComponent,
  getExposedAPIByComponentId,
  saveExposedApiBatchState,
  saveExposedClient,
  saveExposedClientState,
  saveExposedComponent,
  saveExposedComponentState,
  setAPIByClientId,
  setAPIByComponentId,
  setComponentByClientId,
  setDeleteExposedApi,
  setDeleteExposedClient,
  setDeleteExposedComponent,
  setExposedApi,
  setExposedApiAdvanceSearch,
  setExposedApiAutosuggest,
  setExposedClientAdvanceSearch,
  setExposedClientAutosuggest,
  setExposedClientTable,
  setExposedComponent,
  setExposedComponentAdvanceSearch,
  setExposedComponentAutosuggest,
  setExposedComponentTable,
  setNewlyExposedApis
} from '../actions/exposedrest.actions';

export interface ExposedRestsState {
  data: any;
}

export const initialState: ExposedRestsState = {
  data: {}
};

export const exposedrestReducer = createReducer(
  initialState,
  on(saveExposedClientState, (state: any, { success, exposedClient }) => {
    return {
      ...state,
      ...{ exposedClient },
      clientCreateState: success,
      loader: false
    };
  }),
  on(saveExposedComponentState, (state: any, { success, exposedComponent }) => {
    return {
      ...state,
      ...{ exposedComponent },
      componentCreateState: success,
      loader: false
    };
  }),
  on(saveExposedApiBatchState, (state: any, { success, exposedApiBatch }) => {
    return {
      ...state,
      ...{ exposedApiBatch },
      apiBatchCreateState: success,
      loader: false
    };
  }),
  on(setExposedClientTable, (state, { exposedClientTable }) => ({
    ...state,
    loader: false,
    ...{ exposedClientTable }
  })),
  on(saveExposedComponent, (state) => ({
    ...state,
    loader: true
  })),
  on(saveExposedClient, (state) => ({
    ...state,
    loader: true
  })),
  on(setExposedComponentTable, (state, { exposedComponentTable }) => ({
    ...state,
    ...{ exposedComponentTable }
  })),
  on(setExposedComponent, (state: any, { exposedComponent }) => {
    return {
      ...state,
      ...{ exposedComponent }
    };
  }),
  on(setExposedApi, (state, { exposedApi }) => ({
    ...state,
    ...{ exposedApi }
  })),
  on(setNewlyExposedApis, (state, { newlyExposedApiTable }) => ({
    ...state,
    ...{ newlyExposedApiTable }
  })),
  on(saveExposedClient, (state, { exposedClientData }) => ({
    ...state,
    ...exposedClientData
  })),
  on(getExposedAPIByComponentId, (state, { params }) => ({
    ...state,
    componentId: params.functionalcompid
  })),
  on(deleteExposedClient, (state, { ids }) => ({
    ...state,
    ...ids,
    ...{ deletedClient: false }
  })),
  on(setDeleteExposedClient, (state, { deletedClient }) => ({
    ...state,
    ...{ deletedClient: deletedClient }
  })),
  on(deleteExposedComponent, (state, { ids }) => ({
    ...state,
    ...ids,
    ...{ deletedComponent: false }
  })),
  on(setDeleteExposedComponent, (state, { deletedComponent }) => ({
    ...state,
    ...{ deletedComponent: deletedComponent }
  })),
  on(deleteExposedApi, (state, { ids }) => ({
    ...state,
    ...{ ids },
    ...{ deletedApi: false }
  })),
  on(setDeleteExposedApi, (state, { deletedApi }) => ({
    ...state,
    ...{ deletedApi: deletedApi }
  })),
  on(setComponentByClientId, (state, { exposedComponentByClient }) => ({
    ...state,
    ...{ exposedComponentByClient }
  })),
  on(setAPIByComponentId, (state, { exposedAPIByComponent }) => ({
    ...state,
    ...{ exposedAPIByComponent }
  })),
  on(setAPIByClientId, (state, { exposedAPIByClient }) => ({
    ...state,
    ...{ exposedAPIByClient }
  })),
  on(setExposedComponentAutosuggest, (state, { componentAutosuggestResults }) => ({
    ...state,
    ...{ componentAutosuggestResults }
  })),
  on(setExposedApiAutosuggest, (state, { apiAutosuggestResults }) => ({
    ...state,
    ...{ apiAutosuggestResults }
  })),
  on(setExposedClientAutosuggest, (state, { clientAutosuggestResults }) => ({
    ...state,
    ...{ clientAutosuggestResults }
  })),
  on(setExposedClientAdvanceSearch, (state, { clientAdvanceSearchtResults }) => ({
    ...state,
    ...{ clientAdvanceSearchtResults }
  })),
  on(setExposedComponentAdvanceSearch, (state, { componentAdvanceSearchRsults }) => ({
    ...state,
    ...{ componentAdvanceSearchRsults }
  })),
  on(setExposedApiAdvanceSearch, (state, { apiAdvanceSearchResults }) => ({
    ...state,
    ...{ apiAdvanceSearchResults }
  }))
);
